import { FDealType } from '../types';

export function isDailyrent(dealType: FDealType): boolean {
  return dealType === FDealType.RentDaily;
}
